import { createActions, createReducer } from 'reduxsauce';
import { Record, fromJS } from 'immutable';

export const { Types: HomeTypes, Creators: HomeActions } = createActions({
  buyFormReset: [''],
  buyFormRequest: ['data'],
  buyFormSuccess: ['data'],
  buyFormFailure: [''],
}, { prefix: 'HOME_' });

const HomeRecord = new Record({
  buyForm: fromJS({
    isSending: false,
    isFailure: false,
    isSuccess: false,
  })
});

export const INITIAL_STATE = new HomeRecord({});

const buyFormReset = state => state
  .setIn(['buyForm', 'isSending'], false)
  .setIn(['buyForm', 'isSuccess'], false)
  .setIn(['buyForm', 'isFailure'], false);

const buyFormRequest = state => state
  .setIn(['buyForm', 'isSending'], true)
  .setIn(['buyForm', 'isSuccess'], false)
  .setIn(['buyForm', 'isFailure'], false);


const buyFormSuccess = state => state
  .setIn(['buyForm', 'isSending'], false)
  .setIn(['buyForm', 'isSuccess'], true)
  .setIn(['buyForm', 'isFailure'], false);

const buyFormFailure = state => state
  .setIn(['buyForm', 'isSending'], false)
  .setIn(['buyForm', 'isSuccess'], false)
  .setIn(['buyForm', 'isFailure'], true);

export const reducer = createReducer(INITIAL_STATE, {
  [HomeTypes.BUY_FORM_RESET]: buyFormReset,
  [HomeTypes.BUY_FORM_REQUEST]: buyFormRequest,
  [HomeTypes.BUY_FORM_SUCCESS]: buyFormSuccess,
  [HomeTypes.BUY_FORM_FAILURE]: buyFormFailure,
});



// WEBPACK FOOTER //
// ./src/modules/home/home.redux.js